<template>
   <div class="mode-of-payment">
      <van-action-sheet v-model="unlockingShow">
        <div class="content">
            <div class="payment-select">请选择支付方式</div>
             <div class="van-doc-demo-block__card" >
                <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="selectBtn(3)" v-if="userToken&&loginType==2">
                    <div class="van-cell__title">
                        <img src="@/assets/images/balance-ico.png" alt="" class="payment__img">
                        <span class="payment-title">余额 <span >（￥{{personal.userMoney}}）</span></span>
                    </div>
                    <span >&nbsp;</span>
                    <!-- <img :src="paymentCheck" class="payment-check" v-if="paymentIds==3&&disabled" alt=""> -->
                    <van-loading size="24px" class="payment-check" v-if="paymentIds==3&&disabled"></van-loading>
                </div>
                <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="selectBtn(2)" v-if="loginType==2">
                    <div class="van-cell__title">
                        <img src="@/assets/images/weixin-ico.png" alt="" class="payment__img">
                        <span class="payment-title">微信 </span>
                    </div>
                    <span >&nbsp;</span>
                    <!-- <img :src="paymentCheck" class="payment-check" v-if="paymentIds==2&&disabled" alt=""> -->
                    <van-loading size="24px" class="payment-check" v-if="paymentIds==2&&disabled"></van-loading>
                </div>
               <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="selectBtn(1)" v-if="loginType!=2">
                    <div class="van-cell__title">
                        <img src="@/assets/images/alipay-ico.png" alt="" class="payment__img">
                        <span class="payment-title">支付宝 </span>
                    </div>
                    <span >&nbsp;</span>
                    <van-loading size="24px" class="payment-check"  v-if="paymentIds==1&&disabled"></van-loading>
                    <!-- <img :src="paymentCheck" class="payment-check" v-if="paymentIds==1&&disabled" alt=""> -->
                </div>
            </div>
        </div>
      </van-action-sheet>
   </div>
</template>
<script>
// headers
import {mapState} from "vuex";
export default {
    name:"modeOfPayment",
    props: {
        paymentId:{
         type:[Number,String],
         default:''
        },
    },
    watch: {
        paymentId: {
        handler(newValue,oldValue){
          this.paymentIds=newValue
        },
        immediate: true
        }
    },
    computed:{
      ...mapState(['personal'])
    },
    mounted(){
    },
    data () {
        return {
            disabled: false,
            unlockingShow:false,
            paymentIds:4,
            paymentCheck:require("@/assets/images/tick-ico.png"),
        }
    },
    methods: {
        control(){
           this.unlockingShow=!this.unlockingShow
        },
        disabledFn(){
            if(this.disabled){
                this.disabled=false
            }
        },
        selectBtn(index){
            if (this.disabled) { return false }
            this.disabled = true;
            this.paymentIds=index
            this.$emit("selectEvent",this.paymentIds);
            // setTimeout(() => {
            //     this.disabled = false;
            // },1500)
        }
    }
}
</script>
<style  lang='scss' scoped>
.mode-of-payment{
  .content {
    padding: 16px 16px 80px;
  }
  .payment-select{
      line-height: 50px;
      border-bottom:1px solid #ebedf0;
      padding-bottom: 10px;
  }
  .van-cell__title{
      height:58px ;
    .payment__img{
      display: inline-block;
      width: 58px;
      height: 58px;
    }
    .payment-title{
      position: relative;
      top: -18px;
      left: 20px;
    }
  }
  .payment-check{
    display: inline-block;
    width: 48px;
    height: 48px;
    position: relative;
    top: 5px;
   } 
 
}
</style>